import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { baseApi as originBaseApi } from "../services/helpers/baseApi/origin.baseApi";
import { baseApi as adminServiceBaseApi } from "../services/helpers/baseApi/adminService.baseApi";
import { setAccessTokenGetter } from "../services/helpers/authTokenProvider";
import authReducer from "./slices/auth/authSlice";
import storageReducer from "./slices/storage/storageSlice";
import countryReducer from "./slices/country/countrySlice";
import requestReducer from "./slices/request/requestSlice";
import orderReducer from "./slices/order/orderSlice";
import newOrderReducer from "./slices/newOrder/newOrderSlice";


import storage from "redux-persist/lib/storage";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import appReducer from "./slices/app/appSlice";
const persistConfig = {
  key: "auth",
  storage,
};

const persistStorageConfig = {
  key: "storage",
  storage,
  blocklist: ["storages"],
};
const persistCountryConfig = {
  key: "countries",
  storage,
  blocklist: ["countries"],
};

const persistedReducer = persistReducer(persistConfig, authReducer);
const persistedStorageReducer = persistReducer(
  persistStorageConfig,
  storageReducer
);
const persistedCountryReducer = persistReducer(
  persistCountryConfig,
  countryReducer
);

export const store = configureStore({
  reducer: {
    auth: persistedReducer,
    storage: persistedStorageReducer,
    app: appReducer,
    request: requestReducer,
    order: orderReducer,
    newOrder: newOrderReducer,
    country: persistedCountryReducer,
    [originBaseApi.reducerPath]: originBaseApi.reducer,
    [adminServiceBaseApi.reducerPath]: adminServiceBaseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: {
        ignoredPaths: [
          originBaseApi.reducerPath,
          adminServiceBaseApi.reducerPath,
        ],
      },
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(originBaseApi.middleware, adminServiceBaseApi.middleware),
});

setAccessTokenGetter(() => store.getState().auth.accessToken);

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
